import { TokenUserHelper } from "../services/token-user-service";
import { FunctionComponent } from "react";
import { IOlympiadExam } from "../models/olympiadExam";
import { useLocation, useNavigate } from "react-router-dom";
import React from "react";
import { Collapse, List, ListItemButton, ListItemIcon, ListItemText, Tooltip } from "@mui/material";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import QuizIcon from '@mui/icons-material/Quiz';
import { isSelected } from "../utilities/utils";

interface OlympiadExamMenuProps {
    menuCollapsed?: boolean;
    onExpandRequest?: () => void;
}

export const OlympiadExamMenu: FunctionComponent<OlympiadExamMenuProps> = ({ menuCollapsed = false, onExpandRequest = () => {} }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const olympiadExams = TokenUserHelper.GetOlympiadExams();

    const isAnyExamSelected = olympiadExams.some(exam => {
        const examPath = `/OlympiadExam/${exam.examName}`;
        return isSelected(location.pathname, examPath);
    });

    const [open, setOpen] = React.useState(false);

    React.useEffect(() => {
        setOpen(isAnyExamSelected && !menuCollapsed);
    }, [isAnyExamSelected, menuCollapsed]);

    const handleExamClick = (olympiadExam: IOlympiadExam) => {
        navigate('/OlympiadExam/' + olympiadExam.examName);
    };

    if (olympiadExams.length === 0) return null;

    if (menuCollapsed) {
        return (
            <Tooltip title="Olympiad Exams" placement="right">
                <ListItemButton
                    onClick={onExpandRequest}
                    selected={isAnyExamSelected}
                    sx={{ justifyContent: 'center', px: 1 }}
                >
                    <ListItemIcon sx={{ minWidth: 0, justifyContent: 'center' }}>
                        <EmojiEventsIcon />
                    </ListItemIcon>
                </ListItemButton>
            </Tooltip>
        );
    }

    return (
        <>
            <ListItemButton onClick={() => setOpen(!open)} selected={isAnyExamSelected}>
                <ListItemIcon>
                    <EmojiEventsIcon />
                </ListItemIcon>
                <ListItemText primary={'Olympiad Exams'} sx={{ fontSize: '0.875rem' }} disableTypography />
                {open ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>
            <Collapse in={open} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                    {olympiadExams.map((exam, index) => {
                        const examPath = `/OlympiadExam/${exam.examName}`;
                        const selected = isSelected(location.pathname, examPath);
                        return (
                            <ListItemButton
                                key={index}
                                sx={{ pl: 4 }}
                                onClick={() => handleExamClick(exam)}
                                selected={selected}
                            >
                                <ListItemIcon>
                                    <QuizIcon />
                                </ListItemIcon>
                                <ListItemText primary={exam.examName} disableTypography sx={{ fontSize: '0.875rem' }} />
                            </ListItemButton>
                        );
                    })}
                </List>
            </Collapse>
        </>
    );
};
